<div class="row" *ngIf="summary && summary.CurrentGarageVisit">
  <div class="col-12 ">
    <div class="menu-box-visit m-2 p-2">
      <div class="menu-box-visit-text p-1">
        Bierzące umówienie
      </div>
      <div class="menu-box-visit-text p-1">
        {{ summary.CurrentGarageVisit.Date| date:'yyyy.MM.dd  HH:mm'}}
      </div>
      <div class="menu-box-visit-text p-1">
        {{ summary.CurrentGarageVisit.Garage.Name}}
      </div>
      <div class="menu-box-visit-text p-1">
        {{ summary.CurrentGarageVisit.Garage.City}}
        {{ summary.CurrentGarageVisit.Garage.Street}}
      </div>
      <div class="menu-box-visit-text p-1">
        {{ summary.CurrentGarageVisit.Garage.Telephone}}
      </div>
    </div>
  </div>
</div>



<div class="row" *ngIf="deposite && summary && !summary.CurrentGarageVisit">
  <div class="col-12 ">
    <h1>Nowe umówienie wymiany opon z depozytu.</h1>
  </div>
</div>

<div [hidden]="currentStep != 0 || !summary || summary.CurrentGarageVisit">

  <div class="desktop-only d-flex justify-content-center flex-nowrap" *ngIf="deposite && blockedDayList && garageVisitPlaceList">
    <div class="text-white mx-2 p-2">
      <p-calendar [(ngModel)]="currentDate" [numberOfMonths]="2" [inline]=" true" [locale]="localizationCalendarConfig" dateFormat="dd.mm.yyyy" (onSelect)="onSelect($event)" (onMonthChange)="onMonthChange($event)">
        <ng-template pTemplate="date" let-date>
          <span [ngStyle]="{backgroundColor: IsDayBlocked(date) ? '#AAA' : 'inherit'}" style="border-radius: 20%; padding: 2px;">{{date.day}}</span>
        </ng-template>
      </p-calendar>
    </div>
  </div>

  <div class="d-flex justify-content-center flex-nowrap mobile-only" *ngIf="deposite && blockedDayList && garageVisitPlaceList">
    <div class="text-white mx-2 p-2">
      <p-calendar [(ngModel)]="currentDate" [numberOfMonths]="1" [inline]=" true" [locale]="localizationCalendarConfig" dateFormat="dd.mm.yyyy" (onSelect)="onSelect($event)" (onMonthChange)="onMonthChange($event)">
        <ng-template pTemplate="date" let-date>
          <span [ngStyle]="{backgroundColor: IsDayBlocked(date) ? '#AAA' : 'inherit'}" style="border-radius: 20%; padding: 2px;">{{date.day}}</span>
        </ng-template>
      </p-calendar>
    </div>
  </div>

  <div class="d-flex justify-content-center flex-nowrap " *ngIf="deposite && garageVisitPlaceList && garageVisits">
    <div class="text-white mx-2 p-2">
      <table *ngIf="IsGarageOpen()" style="border-spacing: 10px; font-size:14px;" class="garage-visit-place-table">
        <tr>
          <th></th>

          <th *ngIf="GarageVisitPlaceOfflineCount() == 1" style="background-color: #0091D5;">Offline</th>
          <th *ngIf="GarageVisitPlaceOfflineCount() > 1" [attr.colspan]="GarageVisitPlaceOfflineCount()" style="background-color: #0091D5;">Offline</th>

          <th *ngIf="GarageVisitPlaceOnlineCount() == 1" style="background-color: #6AB187; color: white;">Stanowiska</th>
          <th *ngIf="GarageVisitPlaceOnlineCount() > 1" [attr.colspan]="GarageVisitPlaceOnlineCount()" style="background-color: #6AB187;">Stanowiska</th>
        </tr>
        <tr>
          <td style="background-color: #0091D5;">Godziny</td>
          <td *ngFor="let garageVisitPlace of GarageVisitPlaceOffline(); let i = index;" style="background-color: #a8e3ff; color: black;">
            <i class="fa fa-car" aria-hidden="true" *ngIf="IsCarPlace(garageVisitPlace)"></i>

            <i class="fa fa-bus" aria-hidden="true" *ngIf="IsTrackPlace(garageVisitPlace)"></i>

            {{garageVisitPlace.Name}}
          </td>
          <td *ngFor="let garageVisitPlace of GarageVisitPlaceOnline(); let i = index;" style="background-color: #bdffd8; color: black;">
            <i class="fa fa-car" aria-hidden="true" *ngIf="IsCarPlace(garageVisitPlace)"></i>

            <i class="fa fa-bus" aria-hidden="true" *ngIf="IsTrackPlace(garageVisitPlace)"></i>

            {{garageVisitPlace.Name}}
          </td>
        </tr>

        <tr *ngFor="let timeSlot of timeSlots; let i = index;" class="time-slot">
          <td class="time-slot-label">
            {{timeSlot.Label}}
          </td>


          <ng-container *ngFor="let garageVisitPlace of GarageVisitPlaceOnline(); let i = index;">
            <td *ngIf="IsTimeSlotDisplay(timeSlot,garageVisitPlace)" class="time-slot" [ngStyle]="SetTimeSlotStyles(timeSlot,garageVisitPlace)" (click)="AddNewVisit(timeSlot,garageVisitPlace)" [attr.rowspan]="SetRowSpan(timeSlot,garageVisitPlace)">
              <div *ngIf="!IsTimeSlotFree(timeSlot,garageVisitPlace)">
                <span *ngIf="GetGarageVisit(timeSlot,garageVisitPlace).RegistrationNumber && GetGarageVisit(timeSlot,garageVisitPlace).RegistrationNumber.lenght > 0; else Occupied">{{GetGarageVisit(timeSlot,garageVisitPlace).RegistrationNumber}}</span>
                <ng-template #Occupied><span>Zajęte</span></ng-template>
              </div>
              <div *ngIf="IsReservationValid(timeSlot,garageVisitPlace)"><i class="fa fa-plus-square-o" aria-hidden="true"></i></div>
            </td>
          </ng-container>
        </tr>
      </table>

      <div *ngIf="!IsGarageOpen()" class="alert alert-dark mt-3 mb-3"><h3>Brak dostępnych terminów w tym dniu w celu rezerwacji wizyty skontaktuj się telefonicznie z serwisem: {{currentGarage.Name}}, tel. {{currentGarage.Telephone}}.</h3></div>
    </div>
  </div>
</div>


<div [hidden]="currentStep != 1 || !summary || summary.CurrentGarageVisit">

  <div class="col-12 ">
    <h2 *ngIf="currentGarage">{{currentGarage.Name}}</h2>
    <h2 *ngIf="newGarageVisit">{{newGarageVisit.VisitDate| date:'yyyy.MM.dd'}} {{newGarageVisit.TimeSlotLabel}}</h2>
  </div>

  <div class="d-flex justify-content-center flex-nowrap" *ngIf="car">
    <div class="text-white mx-2 p-2">
      <form [formGroup]="formMain">
        <div class="row">
          <div class="col-6">
            <app-control-text-input [placeholder]="'Imię'" [label]="'Imię'" [bindValue]="'FirstName'" [model]="car" [controlName]="inputFirstName" [maxLength]="30" [minLength]="3">
            </app-control-text-input>
          </div>
          <div class="col-6">
            <app-control-text-input [placeholder]="'Nazwisko'" [label]="'Nazwisko'" [bindValue]="'LastName'" [model]="car" [controlName]="inputLastName" [maxLength]="50" [minLength]="3">
            </app-control-text-input>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <app-control-telephone-input [placeholder]="'Nr tel komórkowego'" [label]="'Telefon'" [bindValue]="'PhoneNr'" [model]="car" [controlName]="inputPhoneNr" [isLandlinePhone]="false" (ngValidationError)="onValidationTelephone($event)">
            </app-control-telephone-input>
          </div>

          <div class="col-6">
            <app-control-email-input [placeholder]="'Mail'"[label]="'Mail'"  [bindValue]="'Mail'" (ngValidationError)="onValidationEmail($event)" [model]="car" [controlName]="inputMail">
            </app-control-email-input>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <app-control-text-input [isDisabled]="true" [placeholder]="'Marka'" [label]="'Marka'" [bindValue]="'Brand'" [model]="car">
            </app-control-text-input>
          </div>
          <div class="col-6">
            <app-control-text-input [isDisabled]="true" [placeholder]="'VIN'" [label]="'VIN'" [bindValue]="'Vin'" [model]="car">

              <!--(ngValidationError)="onValidation($event)"-->
            </app-control-text-input>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <app-control-checkbox-input [label]="'Wyrażam zgodę na przetwarzanie moich danych osobowych dla potrzeb niezbędnych do realizacji przez Point-S usługi wymiany opon (zgodnie z Ustawą z dnia 29.08.1997 roku o Ochronie Danych Osobowych; tekst jednolity: Dz. U. z 2002r. Nr 101, poz. 926 ze zm.).'"
                                        [bindValue]="'IsAldConsent'"
                                        [model]="car">
            </app-control-checkbox-input>
          </div>
        </div>


        <div class="row">
          <div class="col-12">
            <app-control-checkbox-input [label]="'Wyrażam zgodę na przetwarzanie przez Point-S  moich danych osobowych w postaci imienia, nazwiska i adresu do korespondencji w celu przesyłania mi informacji marketingowych dotyczących produktów i usług oferowanych przez Point-S za pomocą poczty elektronicznej.'"
                                        [bindValue]="'IsAldConsentToAdvertising'"
                                        [model]="car">
            </app-control-checkbox-input>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-6">
          <button style="margin-bottom: 20px;" [disabled]="false" class="btn btn-primary form-control" (click)="onBack()">
            Zmień termin
          </button>
        </div>
        <div class="col-6">
          <button style="margin-bottom: 20px;" [disabled]="!IsFormValid()" class="btn btn-primary form-control" (click)="onSaveNewVisit()">
            Rezerwuj termin
          </button>
        </div>
      </div>

      <div class="row statute">
        <div class="col-12">
          <strong>Regulamin</strong>
          <ol>
            <li>Usługa rezerwacji stanowiska on-line jest prowadzona i zarządzana przez firmę Point S Polska Sp. z.o.o.</li>
            <li>Zadaniem usługi jest umożliwienie rezerwacji za pośrednictwem sieci Internet wolnego stanowiska w serwisie opon w/w firmy, o ustalonej godzinie w ustalonym dniu na czas 30 minut.</li>
            <li>Rezerwacji jest bezpłatna i może jej dokonać każdy, kto posiada dostęp do Internetu.</li>
            <li>Warunkiem poprawnej rezerwacji jest wprowadzenie imienia i nazwiska rezerwującego, telefonu kontaktowego oraz numeru rejestracyjnego pojazdu.</li>
            <li>Firma Point S. zastrzega sobie możliwość telefonicznego potwierdzenia rezerwacji stanowiska, choć nie jest ono konieczne.</li>
            <li>Spóźnienie dłuższe niż 5 minut powoduje, że termin rezerwacji przepada. Konieczne jest ustalenie nowego, już w standardowym trybie.</li>
            <li>Numer rejestracyjny pojazdu klienta, który nie pojawił się, bądź spóźnił na umówioną godzinę może być przy kolejnych próbach rezerwacji odrzucony przez operatora systemu.</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</div>





<ng-container *ngIf="!deposite || !summary">
  <div class="container z-index-master">
    <div class="row align-items-center">
      <div class="col-md-12">
        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
